import {useZero} from '@/shared/integrations/zero/use-zero'
import {RemakePatientTherapySequenceSchema} from '@cypro/engine/mutators'
import {useCallback} from 'react'

export function useRemakePatientTherapySequence() {
  const zero = useZero()
  return useCallback(
    (payload: RemakePatientTherapySequenceSchema) =>
      zero.attemptMutation(zero.mutators.patientsTherapies.remakePatientTherapySequence(payload), async mutation => {
        await mutation.server
      }),
    [zero]
  )
}
